const downloadFromBlob = (blob: Blob, fileName: string, fileExtension: string) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.${fileExtension}`;
    document.body.appendChild(a); // append the element to the dom
    a.click();
    a.remove(); // afterwards, remove the element  

    window.URL.revokeObjectURL(url);
}

export { downloadFromBlob }